export default __webpack_public_path__ + "static/media/headerImage.5c66f7e0.png";